﻿let $ = require('jquery');
let SpeakersRequest = function (customOptions) {
    let defaults = {
        element: null,
        submitButton: '#speakers-request-sumbit',
        resetButton: '.cancel',
        nameSelector: '#nameValue',
        addressSelector: '#addressValue',
        citySelector: '#cityValue',
        stateSelector: '#stateValue',
        emailSelector: '#emailValue',
        phoneSelector: '#phoneValue',
        organizationSelector: '#organizationValue',
        typeOfEventSelector: '#typeOfEventValue',
        dateOfEventSelector: '#dateOfEventValue',
        speakersSelector: '#speakersValue',
        topicsSelector: '#topicsValue',
        leadSourceSelector: '#leadSource',
        requiredInputs: '.required-input',
        allInputs: '.form-inputs',
        form: 'form.speakers-request-form',
        invalidInputsWarning: '.warning-on-invalid-inputs',
        requiredMessage: '.required'
    };

    let options = $.extend({}, defaults, customOptions);
    let $element = $(options.element);
    let $submitButton = $element.find(options.submitButton);
    let $resetButton = $element.find(options.resetButton);
    let name = $element.find(options.nameSelector);
    let address = $element.find(options.addressSelector);
    let city = $element.find(options.citySelector);
    let state = $element.find(options.stateSelector);
    let email = $element.find(options.emailSelector);
    let phone = $element.find(options.phoneSelector);
    let organization = $element.find(options.organizationSelector);
    let typeOfEvent = $element.find(options.typeOfEventSelector);
    let dateOfEvent = $element.find(options.dateOfEventSelector);
    let speakers = $element.find(options.speakersSelector);
    let topics = $element.find(options.topicsSelector);
    let leadSource = $element.find(options.leadSourceSelector);
    let requiredInputs = $element.find(options.requiredInputs);
    let allInputs = $element.find(options.allInputs);
    let form = $element.find(options.form);
    let scrollOffset = $element.offset().top;
    let requiredMessage = $element.find(options.requiredMessage);
    let invalidInputsWarning = $element.find(options.invalidInputsWarning);


    dateOfEvent.datepicker({
        inline: true
    });

    let validFields = true;

    let validateInputs = function () {
        validFields = true;
        for (var i = 0; i < requiredInputs.length; i++) {
            if (!$(requiredInputs[i]).valid()) {
                validFields = false;
            }
        }
        if (!validFields) {
            invalidInputsWarning.css('display', 'block');
            requiredMessage.css('display', 'none');
            $('html, body').animate({
                scrollTop: $element.find('.input-validation-error:first-child').offset().top -scrollOffset
            }, 500);
            return false;
        }
        else {
            invalidInputsWarning.css('display', 'none');
            requiredMessage.css('display', 'block');
            return true;
        }
    };

    $.fn.clearValidation = function () { var v = $(this).validate(); $('[name]', this).each(function () { v.successList.push(this); v.showErrors(); }); v.resetForm(); v.reset(); };

    $submitButton.on('click', function () {

        if (!validateInputs()) { return; }
        let speakersRequestData = {
            Name: name.val(),
            Address: address.val(),
            City: city.val(),
            State: state.val(),
            Email: email.val(),
            PhoneNumber: phone.val(),
            Organization: organization.val(),
            TypeOfEvent: typeOfEvent.val(),
            DateOfEvent: new Date(dateOfEvent.val()),
            SpeakerName: speakers.val(),
            Topics: topics.val(),
            LeadSource: leadSource.val()
        };

        let currentPage = jnfroutesconfg.ServerUrl;

        $.ajax({
            type: 'POST',
            url: currentPage + 'api/SpeakersRequest',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(speakersRequestData),
            success: function (result, args) {
                console.log(result);
                console.log(args);
                window.location.replace(currentPage + "thank-you");
            },
            error: function (error) {
                console.log(error);
            }
        });
    });
    $resetButton.on('click', function () {
        allInputs.val('');
        invalidInputsWarning.css('display', 'none');
        requiredMessage.css('display', 'block');
        form.clearValidation();
    });
};

module.exports = SpeakersRequest;